// extracted by mini-css-extract-plugin
export var author = "single-testimonial-gray-module--author--f3E-P";
export var content = "single-testimonial-gray-module--content--NOfHs";
export var innerWrapper = "single-testimonial-gray-module--inner-wrapper--DGetU";
export var outerWrapper = "single-testimonial-gray-module--outer-wrapper--x5Ksg";
export var quote = "single-testimonial-gray-module--quote--+xETr";
export var testimonial = "single-testimonial-gray-module--testimonial--DeTWs";
export var text = "single-testimonial-gray-module--text--Aor7J";
export var title = "single-testimonial-gray-module--title--Cl3Bd";